export default __webpack_public_path__ + "static/media/website-icon.bcd3812a.svg";